/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { DatepickerComponent } from '../datepicker/datepicker.component';

@Component({
  selector: 'app-ion-datetime',
  templateUrl: './ion-datetime.component.html',
  styleUrls: ['./ion-datetime.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => IonDatetimeComponent),
    multi: true
}]
})
export class IonDatetimeComponent implements ControlValueAccessor, OnInit, OnDestroy {

  @ViewChild('dateTimeModal') dateTimeModal:any

  private subject = new Subject<any>();

  @Input() cancelText:string;
  @Input() doneText:string;
  @Input() triggerId:string;
  @Input() displayFormat:string;
  @Input() disabled:boolean;
  @Input() required:boolean;
  @Input() presentation = "date";
  @Input() cssClass = "";
  @Input() title = "";
  @Input() form:any;
  @Input() min:any;
  @Input() max:any;

  private _change = false;

  locale="de-DE";

  async ngOnInit(): Promise<any> {
    this.cssClass = this.cssClass+' dateTimeModal';

    this.subject.subscribe({next: (value) => {
      this._change = true;
      this.writeValue(value);
    }, error: (error) => {
      console.log(error);
    }})

  }

  ngOnDestroy(): void {
    this.subject.unsubscribe();
  }

   /**
  * Holds the current value of the slider
  */
 value: any = '';

 /**
  * Invoked when the model has been changed
  */
 onChange: (_: any) => void = (_: any) => {};

 /**
  * Invoked when the model has been touched
  */
 onTouched: () => void = () => {};

  constructor(private modal:ModalController) { }

   /**
  * Method that is invoked on an update of a model.
  */
 updateChanges() {
  if(this.value === undefined)
    this.value = '';
  this.onChange(this.value);
}

 ///////////////
 // OVERRIDES //
 ///////////////

 /**
  * Writes a new item to the element.
  * @param value the value
  */
  writeValue(value: any): void {
    if(value !== null) {
      this.value = value;
      if(this._change) {
        this.updateChanges();
        if(this.form) {
          this.form.control.markAsDirty();
        }
      }
    }
}

/**
 * Registers a callback function that should be called when the control's value changes in the UI.
 * @param fn
 */
registerOnChange(fn: any): void {
    this.onChange = fn;
}

/**
 * Registers a callback function that should be called when the control receives a blur event.
 * @param fn
 */
registerOnTouched(fn: any): void {
    this.onTouched = fn;
}

dismissModal() {
  this.dateTimeModal.dismiss();
}

async openPicker() {

  const mod = await this.modal.create({
    component: DatepickerComponent,
    cssClass: this.cssClass,
    componentProps: {
     title:this.title,
     locale:this.locale,
     disabled:this.disabled,
     cancelText:this.cancelText,
     doneText:this.doneText,
     value:this.value,
     min:this.min,
     max:this.max,
     presentation:this.presentation,
     subject:this.subject 
    }
  });
  mod.present();
}
}
